import $ from 'jquery';

var backend = $('#wpen-backend-json').attr('content');
backend = backend ? $.parseJSON(backend) : {};

export default backend;
